export default __webpack_public_path__ + "static/media/flowchart_whitebg_mobile.f9784087.png";